// extracted by mini-css-extract-plugin
module.exports = {"avatar":"WebhookEndpointItemRow_avatar__1WUGJ"};